<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
export default {
  components: {
    VueMultiselect: Multiselect,
  },
  props: [
    "extra_params",
    "send_null",
    "full_object",
    "search_api",
    "optionsData",
    "search_without_api",
    "track_by",
    "display",
    "multi_select",
    "selected_data",
    "selected_by",
    "merge_display",
    "disabled",
    "id_required",
  ],
  data() {
    return {
      options: [],
      selectedOption: null,
      search: "",
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      change_in_progress: false,
    };
  },
  watch: {
    selected_data: {
      deep: true,
      async handler(v) {
        if (
          this.selected_by != "text" &&
          this.options.filter((f) => v.includes(f[this.selected_by])).length > 0
        ) {
          return;
        }
        if (this.selectedOption == null && v[0] != null && v[0] != "") {
          await this.fetchDataWithId(v[0]);
          if (!this.multi_select || this.multi_select == false) {
            this.selectedOption = this.options.filter((f) =>
              v.includes(f[this.selected_by])
            )[0];
          } else {
            this.selectedOption = this.options.filter((f) =>
              v.includes(f[this.selected_by])
            );
          }
        }
      },
    },
    optionsData: {
      deep: true,
      handler(v) {
        this.options = v;
      },
    },
    search() {
      this.fetchData();
    },
    selectedOption: {
      deep: true,
      handler(v) {
        if (v || this.send_null == true) {
          if (v == null) {
            this.$emit("selectedOption", v);
          } else {
            if (this.full_object) {
              this.$emit("selectedOption", v);
            } else {
              if (this.multi_select) {
                this.$emit(
                  "selectedOption",
                  v.map((k) => k[this.track_by])
                );
              } else {
                this.$emit("selectedOption", v[this.track_by]);
              }
            }
          }
        }
      },
    },
  },
  async mounted() {
    if (this.search_without_api === true) {
      this.options = this.optionsData;
    } else {
      if (this.id_required != true) {
        await this.fetchData("");
      }
    }
    if (
      this.selected_data &&
      this.selected_data.length > 0 &&
      this.selectedOption == null
    ) {
      await this.fetchDataWithId(this.selected_data[0]);
      if (!this.multi_select || this.multi_select === false) {
        this.selectedOption = this.options.filter((f) =>
          this.selected_data.includes(f[this.selected_by])
        )[0];
      } else {
        this.selectedOption = this.options.filter((f) =>
          this.selected_data.includes(f[this.selected_by])
        );
      }
    }
  },
  methods: {
    async fetchData(s) {
      try {
        if (this.search_without_api === true) {
          return;
        }
        // if (s === undefined || s === "") {
        //   return;
        // }
        let res = await axios.get(
          this.baseUrl +
            this.search_api +
            "?search=" +
            s +
            (this.extra_params ? this.extra_params : "")
        );
        if (res.data.status) {
          this.options = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async fetchDataWithId(id) {
      if (id === undefined || id === "" || id === null) {
        return;
      }
      try {
        if (this.search_without_api === true) {
          return;
        }
        if (id === undefined || id === "") {
          return;
        }
        let res = await axios.get(
          this.baseUrl +
            this.search_api +
            "?id=" +
            id +
            (this.extra_params ? this.extra_params : "")
        );
        if (res.data.status) {
          this.options = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    nameWithLang(item) {
      if (this.merge_display && this.merge_display.length > 0) {
        if (this.merge_display[0].split(".").length == 1) {
          return `${item[this.merge_display[0]]} — [${
            item[this.merge_display[1]]
          }]`;
        } else {
          return `${
            item[this.merge_display[0].split(".")[0]][
              this.merge_display[0].split(".")[1]
            ]
          } — [${
            item[this.merge_display[1].split(".")[0]][
              this.merge_display[1].split(".")[1]
            ]
          }]`;
        }
      } else {
        return `${item[this.display]}`;
      }
    },
  },
};
</script>

<template>
  <div>
    <!--    <b-form-select v-model="selectedOption" :options="filteredOptions" filter>-->
    <!--      <option :value="option.id" v-for="option in options" :key="option.id">{{ option.label }}</option>-->
    <!--    </b-form-select>-->
    <VueMultiselect
      :options="options"
      :show-labels="false"
      v-model="selectedOption"
      :custom-label="nameWithLang"
      :multiple="multi_select ?? false"
      :searchable="true"
      :options-limit="300"
      :limit="3"
      :max-height="600"
      @search-change="fetchData"
      :track-by="track_by ?? 'value'"
      :label="display ?? 'label'"
      :disabled="disabled || false"
    ></VueMultiselect>
  </div>
</template>

<style scoped></style>
